import { Outlet, NavLink, Link } from "react-router-dom";

import gmlogo from "../../assets/GM-logo-2021.png";

import styles from "./Layout.module.css";

const Layout = () => {
    return (
        <div className={styles.layout}>
            <header className={styles.header} role={"banner"}>
                <div className={styles.headerContainer}>
                    <Link to="/" className={styles.headerTitleContainer}>
                        <img src={gmlogo} alt="GM logo" aria-label="Link to GM Website" width="24px" height="24px" className={styles.gmLogo} />

                        <h3 className={styles.headerTitle}> GM Aristotle </h3>
                    </Link>
                    <nav>
                        <ul className={styles.headerNavList}>
                            {/*<li>*/}
                            {/*    <NavLink to="/" className={({ isActive }) => (isActive ? styles.headerNavPageLinkActive : styles.headerNavPageLink)}>*/}
                            {/*        Chat*/}
                            {/*    </NavLink>*/}
                            {/*</li>*/}
                            <li className={styles.headerNavLeftMargin}>
                                <NavLink to="/" className={({ isActive }) => (isActive ? styles.headerNavPageLinkActive : styles.headerNavPageLink)}>
                                    Translate
                                </NavLink>
                            </li>
                            {/*<li className={styles.headerNavLeftMargin}>*/}
                            {/*    <NavLink to="/sentiment" className={({ isActive }) => (isActive ? styles.headerNavPageLinkActive : styles.headerNavPageLink)}>*/}
                            {/*        Sentiment Analysis*/}
                            {/*    </NavLink>*/}
                            {/*</li>*/}
                        </ul>
                    </nav>
                    {/*<h4 className={styles.headerRightText}>Azure OpenAI + Cognitive Search</h4>*/}
                </div>
            </header>

            <Outlet />
        </div>
    );
};

export default Layout;
